
import {
  SEND_CODE_REQUEST,
  SEND_CODE_SUCCESS,
  SEND_CODE_FAILURE,
  VERIFY_CODE_REQUEST,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_FAILURE,
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  CLEAR_MESSAGE
} from "./actionTypes";

export const sendCodeRequest = (firstName, lastName, email) => ({
  type: SEND_CODE_REQUEST,
  payload: { firstName, lastName, email },
})

export const sendCodeSuccess = ( email, message) => ({
  type: SEND_CODE_SUCCESS,
  payload: { email, message },
})

export const sendCodeFailure = (error) => ({
  type: SEND_CODE_FAILURE,
  payload: error,
})

export const verifyCodeRequest = (email, code, consentMarketing = false) => ({
  type: VERIFY_CODE_REQUEST,
  payload: { email, code, consentMarketing: Boolean(consentMarketing) },
})

export const verifyCodeSuccess = ( email, message) => ({
  type: VERIFY_CODE_SUCCESS,
  payload: { email, message },
})

export const verifyCodeFailure = (error) => ({
  type: VERIFY_CODE_FAILURE,
  payload: error,
})

export const registerUser = (email, password, role, history) => ({
  type: REGISTER_USER,
  payload: { email, password, role, history },
})

export const registerUserSuccessful = (user) => ({
  type: REGISTER_USER_SUCCESSFUL,
  payload: user,
})

export const registerUserFailed = (error) => ({
  type: REGISTER_USER_FAILED,
  payload: error,
})

export const clearMessage = (error) => ({
  type: CLEAR_MESSAGE
})
